import { FC, useEffect, useRef } from 'react';
import { consentCopy, ConsentCopy } from './copy';
import { useConsent } from './useConsent';
import './consent.css';

/**
 * The consent bar. Reject and Accept are the same button, side by side, reject first: declining is as
 * easy as agreeing. Reopened from the footer, it says what the current choice is and can be closed
 * without changing it.
 */
const ConsentBanner: FC<{ copy?: ConsentCopy }> = ({ copy = consentCopy }) => {
    const { decided, analytics, bannerOpen, accept, reject, close } = useConsent();
    const bar = useRef<HTMLElement>(null);

    // Reopened by a keyboard user from the footer: bring them to it. Not on first load, where it
    // shouldn't take focus from the page.
    useEffect(() => {
        if (bannerOpen && decided) bar.current?.focus();
    }, [bannerOpen, decided]);

    if (!bannerOpen) return null;

    return (
        <section className="consent" role="region" aria-label={copy.label} tabIndex={-1} ref={bar}>
            <div className="consent__copy">
                <p className="consent__title">{copy.title}</p>
                <p className="consent__body">{copy.body}</p>
                {decided && <p className="consent__status">{analytics ? copy.currentlyOn : copy.currentlyOff}</p>}
            </div>
            <div className="consent__actions">
                <button type="button" className="btn btn-secondary" onClick={reject}>
                    {copy.reject}
                </button>
                <button type="button" className="btn btn-secondary" onClick={accept}>
                    {copy.accept}
                </button>
                {decided && (
                    <button type="button" className="btn btn-ghost" onClick={close}>
                        {copy.close}
                    </button>
                )}
            </div>
        </section>
    );
};

export default ConsentBanner;
